import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSearchParam = (key: string) => {
  const [searchParams] = useSearchParams();

  return useMemo(() => searchParams.get(key), [searchParams, key]);
};
